import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LeadService {

  constructor(private http: HttpClient) { }

  // ─── Core Lead CRUD ────────────────────────────────────────────────────────
  getAllData(data: any): Observable<any> {
    return this.http.post(environment.getAllLeads, data);
  }
  addLeadData(data: any): Observable<any> {
    return this.http.post(environment.createLead, data);
  }
  getLead(data: any): Observable<any> {
    return this.http.post(environment.getLead, data);
  }
  updateLead(data: any): Observable<any> {
    return this.http.post(environment.updateLead, data);
  }

  // ─── Follow-ups ───────────────────────────────────────────────────────────
  addLeadFollowUp(data: any): Observable<any> {
    return this.http.post(environment.createleadsfollowup, data);
  }
  updateLeadFollowUp(data: any): Observable<any> {
    return this.http.post(environment.updateleadsfollowup, data);
  }
  getLeadFollowups(data: any): Observable<any> {
    return this.http.post(environment.getleadsfollowup, data);
  }

  // ─── Pipelines ────────────────────────────────────────────────────────────
  getPipelines(data: any): Observable<any> {
    return this.http.post(environment.getPipelines, data);
  }
  createPipeline(data: any): Observable<any> {
    return this.http.post(environment.createPipeline, data);
  }
  updatePipeline(data: any): Observable<any> {
    return this.http.post(environment.updatePipeline, data);
  }
  deletePipeline(data: any): Observable<any> {
    return this.http.post(environment.deletePipeline, data);
  }


  // ─── Dynamic Fields ──────────────────────────────────────────────────────
  getDynamicFields(data: any): Observable<any> {
    return this.http.post(environment.getLeadDynamicField, data);
  }
  saveDynamicFields(data: any): Observable<any> {
    return this.http.post(environment.createLeadDynamicField, data);
  }
  updateDynamicFields(data: any): Observable<any> {
    return this.http.post(environment.updateLeadDynamicField, data);
  }

  // ─── Activity Log ─────────────────────────────────────────────────────────
  getLeadActivityLog(data: any): Observable<any> {
    return this.http.post(environment.getLeadActivityLog, data);
  }

  // ─── Communications ──────────────────────────────────────────────────────
  createLeadCommunication(data: any): Observable<any> {
    return this.http.post(environment.createLeadCommunication, data);
  }
  getLeadCommunications(data: any): Observable<any> {
    return this.http.post(environment.getLeadCommunications, data);
  }

  // ─── Tasks ───────────────────────────────────────────────────────────────
  createLeadTask(data: any): Observable<any> {
    return this.http.post(environment.createLeadTask, data);
  }
  updateLeadTask(data: any): Observable<any> {
    return this.http.post(environment.updateLeadTask, data);
  }
  getLeadTasks(data: any): Observable<any> {
    return this.http.post(environment.getLeadTasks, data);
  }
  deleteLeadTask(data: any): Observable<any> {
    return this.http.post(environment.deleteLeadTask, data);
  }

  // ─── Meetings ─────────────────────────────────────────────────────────────
  scheduleMeeting(data: any): Observable<any> {
    return this.http.post(environment.scheduleMeeting, data);
  }
  getAvailableTimeSlots(data: any): Observable<any> {
    return this.http.post(environment.getAvailableTimeSlots, data);
  }
  getLeadMeeting(data: any): Observable<any> {
    return this.http.post(environment.getLeadMeeting, data);
  }

  // ─── Bulk & Advanced Operations ──────────────────────────────────────────
  createBulkLead(data: any): Observable<any> {
    return this.http.post((environment as any).createBulkLead, data);
  }
  getAllLeadList(data: any): Observable<any> {
    return this.http.post((environment as any).getAllLeadList, data);
  }
  leadAdvanceFilter(data: any): Observable<any> {
    return this.http.post((environment as any).leadAdvanceFilter, data);
  }
  bulkUpdateLeads(data: any): Observable<any> {
    return this.http.post((environment as any).bulkUpdateLeads, data);
  }
  bulkDeleteLeads(data: any): Observable<any> {
    return this.http.post((environment as any).bulkDeleteLeads, data);
  }
  bulkEmailLeads(data: any): Observable<any> {
    return this.http.post((environment as any).bulkEmailLeads, data);
  }
}

